import { styled } from '@mui/material';

export const FooterContainer = styled('footer', {
  shouldForwardProp: (prop) => prop !== 'enabledLateralMenu',
})<{ enabledLateralMenu: boolean }>(({ theme, enabledLateralMenu }) => ({
  backgroundColor: theme.palette.background.paper,
  padding: theme.spacing(2),
  justifyContent: 'space-between',
  display: 'flex',

  ...(enabledLateralMenu && {
    marginLeft: theme.maxWidths.lateralMenu,
  }),
}));

export const FooterNameContainer = styled('footer')(({ theme }) => ({
  gap: theme.spacing(1),
  display: 'flex',
}));
